import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";
import { getContent } from "@js/helpers/state.js";

export const ceModalDownloadContentCancel = () => ({
  type: CE_MODAL_CLOSE,
});

export const CE_MODAL_DOWNLOAD_CONTENT_SHOW = "CE_MODAL_DOWNLOAD_CONTENT_SHOW";
export const ceModalDownloadContentShow = (clientContentID) => ({
  type: CE_MODAL_DOWNLOAD_CONTENT_SHOW,
  client_content_id: clientContentID,
});

export const ceModalDownloadContentSuccess = () => ({
  type: CE_MODAL_CLOSE,
});

export const ceModalAttemptDownloadContent = (clientContentID, format) => (
  dispatch,
  getState,
) => {
  dispatch(ceModalDownloadContentShow(clientContentID));

  let attempt = () => {
    let {
      data_generation_id,
      last_published_generation_id,
      publish_in_progress,
    } = getState().sync;
    let { campaign_id } = getState();
    let content = getContent(getState(), clientContentID);
    if (
      data_generation_id !== last_published_generation_id ||
      publish_in_progress
    ) {
      setTimeout(attempt, 1000);
    } else {
      dispatch(ceModalDownloadContentSuccess());

      var url = Routes.campaign_content_path(campaign_id, content.id, {
        download: format,
      });
      var win = window.open(url, "_blank");
      win.focus();
    }
  };
  attempt();
};
